var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vueper-slides",
    {
      staticClass: "no-shadow sliders",
      attrs: {
        "transition-speed": "250",
        autoplay: "",
        arrows: false,
        "slide-ratio": 1 / 1.2
      },
      scopedSlots: _vm._u([
        {
          key: "bullet",
          fn: function(ref) {
            var active = ref.active
            return [_c("i", { staticClass: "icon", class: { active: active } })]
          }
        }
      ])
    },
    [
      _c("vueper-slide", { attrs: { image: _vm.SliderUserValue } }),
      _vm._v(" "),
      _c("vueper-slide", { attrs: { image: _vm.SliderPositive } }),
      _vm._v(" "),
      _c("vueper-slide", { attrs: { image: _vm.SliderLove } }),
      _vm._v(" "),
      _c("vueper-slide", { attrs: { image: _vm.SliderInnovation } }),
      _vm._v(" "),
      _c("vueper-slide", { attrs: { image: _vm.SliderTrust } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2d55be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2d55be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sliders.vue
// module id = null
// module chunks = 